import { core } from '@/components/services/settings/smpp/ipWhitelist/mixins'

import render from './render'

export default {
  name: 'Textarea',

  mixins: [ core ],

  props: {
    clearable: Boolean,

    details: {
      type: Boolean,
      default: true
    }
  },

  render
}
